import { Add, Create } from "@mui/icons-material";
import { Fab } from "@mui/material";

interface NewItemFabInterface {
    onClick: () => void;
}

function NewItemFab({ onClick }: NewItemFabInterface) {

    return (
        <Fab
            style={{
                backgroundColor: 'green',
                position: 'fixed',
                bottom: '16px',
                right: '16px',
                zIndex: 1000,
                }}
                aria-label="add"
                onClick={onClick}
        >
            <Add style={{ color: 'white' }}/>
    
        </Fab>
    );
}
export default NewItemFab;